import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { NgSelectModule } from '@ng-select/ng-select';

import { CommonUiModule, SortableColumnModule } from '@tablesready/common-ui';
import { CustomersComponent } from './customers.component';
import { AddEditCustomerComponent } from './modals/add-edit-customer/add-edit-customer.component';
import { VisitInfoCustomerComponent } from './modals/visit-info-customer/visit-info-customer.component';
import { CustomersRoutingModule } from './customers-routing.module';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { LocationSwitcherModule } from '@tablesready/frontend-location-switcher';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { CustomerCustomFieldsComponent } from './customer-custom-fields/customer-custom-fields.component';

@NgModule({
  declarations: [
    CustomersComponent,
    AddEditCustomerComponent,
    VisitInfoCustomerComponent,
    CustomerCustomFieldsComponent,
  ],
  imports: [
    CommonModule,
    CommonUiModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CustomersRoutingModule,
    Angulartics2Module,
    LocationSwitcherModule,
    SortableColumnModule,
    NgSelectModule,
    NgbDatepickerModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendPullRefreshModule,
    FrontendModalModule,
  ],
})
export class CustomersModule {}
